export default {
	_version: '0.0.22',
	_lifetimeInSeconds: 14400,
	clear: window.localStorage.clear,
	removeItem: window.localStorage.removeItem,
	key: window.localStorage.key,
	getItem(key) {
		let item = JSON.parse(window.localStorage.getItem(key))
		if(!item || !item.payload || !item.expires || item.expires < Date.now() || item.version != this._version){
			return null
		}
		this.setItem(key, item.payload)
		return item.payload
	},
	setItem(key, data){
		return window.localStorage.setItem(key, JSON.stringify({
			expires: (Date.now() + (1000*this._lifetimeInSeconds)),
			payload: data,
			version: this._version
		}))
	},
}